(function($) {
    var $fn = $(".comp_product_detail");

    if($fn.length){
        var $slider = $fn.find("[data-slider]"),
            $slider_caption = $fn.find("[data-slider-caption]"),
            $current = $fn.find("[data-current]");

        if($slider.children().length > 1){
            $slider.slick({
                accessibility: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: true,
                dots: false,
                swipeToSlide: true,
                asNavFor: $slider_caption,
                prevArrow: "<i class=\"icon--previous slick-prev\"></i>",
                nextArrow: "<i class=\"icon--next slick-next\"></i>",
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 481,
                        settings: {
                            arrows: true,
                            dots:false,
                            prevArrow: "<i class=\"icon--previous slick-prev\"></i>",
                            nextArrow: "<i class=\"icon--next slick-next\"></i>"
                        }
                    }
                ]
            });
            $slider_caption.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: false,
                dots: false,
                accessibility: false,
                draggable: false,
                swipe:false,
                asNavFor: $slider
            });

            $slider.on('afterChange', function(event, slick, currentSlide){
                $current.text(currentSlide+1);
            });
        }
    }
})(jQuery);